import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { LsMultiCheckboxComponent } from './ls-multi-checkbox.component';
import { LsFormCheckboxModule } from '../ls-checkbox/ls-form-checkbox.module';
import { LsFormMultiCheckboxComponent } from './ls-form-multi-checkbox.component';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, LsFormCheckboxModule],
  declarations: [LsMultiCheckboxComponent, LsFormMultiCheckboxComponent],
  exports: [LsMultiCheckboxComponent, LsFormMultiCheckboxComponent]
})
export class LsMultiCheckboxModule {}
